import Vue from 'vue'
import Vuex from 'vuex'
// import myAge from './Modules/age'
// import myName from './Modules/name';

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    resources: {
      me: {},
      products: [],
      pg: []
    },
    toEdit: 0,
    toDuplicate: 0,
    toDetails: 0,
    toOrders: 0,
    toReorder: null,
    toSearch: null
  },
  getters: {
    getResources(state) {
      return state.resources;
    }
  },
  mutations: {
    setResources(state, resources) {
      state.resources = resources;
    },
    setToEdit(state, id) {
      state.toEdit = id;
    },
    setToDuplicate(state, id) {
      state.toDuplicate = id;
    },
    setToDetails(state, id) {
      state.toDetails = id;
    },
    setToOrders(state, id) {
      state.toOrders = id;
    },
    setToReorder(state, id = null) {
      if (id) {
        state.toReorder = id;
      } else {
        state.toReorder = null;
      }
    },
    setToSearch(state, value = null) {
      const text = value === null || value === undefined ? '' : String(value).trim();
      state.toSearch = text === '' ? null : text;
    }
  },
  actions: {
    apiResources(context, payload = null) {
      return Vue.http
        .get("resources")
        .then(response => response.json())
        .then(response => {
          context.commit("setResources", response);
          // Apply favicon if present
          if (response && response.favicon) {
            let faviconUrl = response.favicon;
            if (!faviconUrl.startsWith('data:') && !faviconUrl.startsWith('http')) {
              faviconUrl = 'img/' + faviconUrl;
            }
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            link.href = faviconUrl;
          }
          return response;
        })
        .catch(response => {
          context.commit("setResources", null);
          throw response;
        });
    }
  },
  modules: {
    // myAge,
    // myName
  }
});
